export const FETCH_TASK_DETAILS = 'src/Correspondent/TaskDetails/action/Fetch_Task_Details';
export const FETCH_TASK_DETAILS_SUCCESS = 'src/Correspondent/TaskDetails/action/Fetch_Task_Details_Success';
export const FETCH_TASK_DETAILS_FAILURE = 'src/Correspondent/TaskDetails/action/Fetch_Task_Details_Failure';
export const fetchTaskDetails = (data) => {
    return {
        type: FETCH_TASK_DETAILS,
        data
    }
}
export const fetchTaskDetailsSuccess = (data) => {
    return {
        type: FETCH_TASK_DETAILS_SUCCESS,
        data
    }
}
export const fetchTaskDetailsFailure = (data) => {
    return {
        type: FETCH_TASK_DETAILS_FAILURE,
        data
    }
}

export const DOWNLOAD_ALL_TASK_TEMPLATE = 'src/Correspondent/TaskDetails/action/Download_All_Task_Template';
export const DOWNLOAD_ALL_TASK_TEMPLATE_SUCCESS = 'src/Correspondent/TaskDetails/action/Download_All_Task_Template_Success';
export const DOWNLOAD_ALL_TASK_TEMPLATE_FAILURE = 'src/Correspondent/TaskDetails/action/Download_All_Task_Template_Failure';
export const downloadAllTaskTemplate = (data) => {
    return {
        type: DOWNLOAD_ALL_TASK_TEMPLATE,
        data
    }
}
export const downloadAllTaskTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_ALL_TASK_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadAllTaskTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_ALL_TASK_TEMPLATE_FAILURE,
        data
    }
}

export const DOWNLOAD_TASK = 'src/Correspondent/TaskDetails/action/Download_Task';
export const DOWNLOAD_TASK_SUCCESS = 'src/Correspondent/TaskDetails/action/Download_Task_Success';
export const DOWNLOAD_TASK_FAILURE = 'src/Correspondent/TaskDetails/action/Download_Task_Failure';
export const downloadTask = (data) => {
    return {
        type: DOWNLOAD_TASK,
        data
    }
}
export const downloadTaskSuccess = (data) => {
    return {
        type: DOWNLOAD_TASK_SUCCESS,
        data
    }
}
export const downloadTaskFailure = (data) => {
    return {
        type: DOWNLOAD_TASK_FAILURE,
        data
    }
}

export const UPLOAD_TASK = 'src/Correspondent/TaskDetails/action/Upload_Task';
export const UPLOAD_TASK_SUCCESS = 'src/Correspondent/TaskDetails/action/Upload_Task_Success';
export const UPLOAD_TASK_FAILURE = 'src/Correspondent/TaskDetails/action/Upload_Task_Failure';
export const uploadTask = (data) => {
    return {
        type: UPLOAD_TASK,
        data
    }
}
export const uploadTaskSuccess = (data) => {
    return {
        type: UPLOAD_TASK_SUCCESS,
        data
    }
}
export const uploadTaskFailure = (data) => {
    return {
        type: UPLOAD_TASK_FAILURE,
        data
    }
}

